import OtcPayIcon from './OtcPayIcon.vue';

OtcPayIcon.install = (Vue) => {
  Vue.component(OtcPayIcon.name, OtcPayIcon);
};

export default OtcPayIcon;
